let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("lI20R")]).then(() => parcelRequire('7y0yx'));